import React from 'react';
import OKAPI from '@api';
import to from 'await-to-js';
import _get from 'lodash/get';


const LocaleContext = React.createContext();
const normalizePopularData = (raw) => {
    if (!Array.isArray(raw)) {
        return [];
    }

    const isGrouped = raw.length > 0 && raw.every((entry) => entry && Array.isArray(entry.items));

    if (isGrouped) {
        return raw.map((group) => ({
            title: group.title || '',
            label: group.label || '',
            icon: group.icon || '',
            color: group.color || '',
            items: Array.isArray(group.items) ? group.items : []
        }));
    }

    return [{
        title: '',
        label: '',
        icon: '',
        color: '',
        items: raw
    }];
}


class LocaleProvider extends React.Component {
    state = {
        isLoading: false,
        baseKey: ['qms-popular-searches'],
        popularData: [],
        queueTicker: ''

    }

    getBlock = async(facilityId) => {
        this.setState({
            isLoading: true
        });
        let popularData = this.state.popularData;
        let queueTicker = this.state.queueTicker;
        const { baseKey } = this.state;
        const keys = baseKey.map((e) => `${e}-${facilityId}`).join(',');
        const [err, response] = await to(OKAPI.locale.GetBlockBulk({
            keys: keys + `,queue-ticker-${facilityId}`, 
            lang: 'id' 
        }));

        if (err) {
            popularData = [];
            queueTicker = '';
        }

        if(response) {
            const datax = _get(response, 'data.data') || [];
            datax.map((i) => {
                if (i.key.includes('queue-ticker')) {
                    queueTicker = i.value;
                }
                if(i.key.includes('qms-popular-searches')) {
                    try{
                        popularData = normalizePopularData(JSON.parse(i.value));
                    }catch(err) {
                        popularData = [];
                    }
                }
            });
        }

        this.setState({
            popularData,
            queueTicker,
            isLoading: false
        })
    }

    render() {
        const value = {
            ...this.state,
            actions: {
                getBlock: this.getBlock
            }
        };
        
        return (
            <LocaleContext.Provider value={value}>{this.props.children}</LocaleContext.Provider>
        );
    }
}

export { LocaleProvider, LocaleContext };